import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Sources from './sources-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Sources {...validProps} />;
}
SvgComponent.iconName = 'sources';

export const SourcesIcon = svgIconWrapper(SvgComponent);
